export const isConnectedSelector = (state) => state.socket.connected;
